export default "__VITE_ASSET__078ed84a__"